import styled from "styled-components";


export const Wrapper = styled.section`
  &.main-container {
    margin-top: 40px;
    margin-bottom: 170px;
  }
    .pagination-div {
        display: flex;
        justify-content: flex-end;
    }
  @media only screen and (max-width: 1249px) {
    &.main-container {
    margin-bottom: 40px;
    }
  }
`;


export const TitleDiv = styled.div`
    display: flex;
    margin-bottom: 28px;
    margin-top: 28px;
    align-items: center;
    justify-content: space-between;
    button{
        display:flex;
        align-items: center;
        gap:4px;
        border-radius: 4px;
        background: #1C4F9E;
        padding: 12px 24px;
        color: #FFF;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        cursor: pointer;
    }
    .title{
        color: #000;
        font-family: "Saira Semi Condensed", sans-serif;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: center;
    }
    img{
        cursor: pointer;;
    }
`;

export const DraftRoomContainer= styled.div`
    font-family: "Saira Semi Condensed", sans-serif;
    padding: 27px 37px;
    width: 100%;
    border-radius: 12px;
    background: #FFF;
    display: flex;
    flex-direction: column;
  `;